export default {
  '403': '当前操作没有权限',
  '404': '资源不存在',
  '417': '未绑定登录账号，请使用密码登录后绑定',
  '422': '用户名不存在或密码错误',
  '426': '验证码错误,请重新输入',
  'default': '系统未知错误,请反馈给管理员'
}
